import React, { useContext, useEffect, useState } from "react";

import DataContext from "../../../../../context/DataContext";
import axios from "../../../../api/axios";
import LoadingIndicator from "../../../../global/LoadingIndicator";

import AccountSettings from "./AccountSettings";
import OrgPermissions from "./OrgPermissions";
import ProfileInfo from "./ProfileInfo";

export default function MyAccount({ children }) {
  const { loggedInUser } = useContext(DataContext);
  const [trigger, setTrigger] = useState(false);
  const [userInfo, setUserInfo] = useState("");
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [managedLocations, setManagedLocations] = useState([]);

  useEffect(() => {
    if (loggedInUser.entity && loggedInUser.entity.entity_type_label === "Provider") {
      axios
        .get(`/api/provider/?limit=100&managed_by=${loggedInUser.pk}`, {
        })
        .then((response) => {
          setManagedLocations(response.data.results);
        });
    }
  }, [loggedInUser, setManagedLocations]);

  useEffect(() => {
    setLoading(true);
    axios
      .get(`/api/users/me/`, {
      })
      .then((response) => {
        const data = response.data;
        setUserInfo(data);
        setLoading(false);
      })
      .catch((_error) => {
        setLoading(false);
        setErrorMessage("There was an error loading this content");
      });
  }, [setUserInfo, trigger]);

  const renderContent = () => {
    if (loading) {
      return <LoadingIndicator isLoading={loading} />;
    } else if (!userInfo && errorMessage) {
      return <p>{errorMessage}</p>;
    } else {
      return (
        <div className="relative h-full w-full">
          <div className="h-full w-full xl:flex">
            <ProfileInfo
              userInfo={userInfo}
              trigger={trigger}
              setTrigger={setTrigger}
              myAccount={true}
              managedLocations={managedLocations}
            />
            <div className="overflow-y-auto xl:h-full xl:w-8/12">
              {children && React.Children.map(children, (child) => React.cloneElement(child))}
              <AccountSettings
                userInfo={userInfo}
                trigger={trigger}
                setTrigger={setTrigger}
                myAccount={true}
              />
              <OrgPermissions
                userInfo={userInfo}
                trigger={trigger}
                setTrigger={setTrigger}
                myAccount={true}
                managedLocations={managedLocations}
              />
            </div>
          </div>
        </div>
      );
    }
  };

  return <div className="h-full">{renderContent()}</div>;
}
